export default "__VITE_ASSET__BjQhL2l$__"